import { render, staticRenderFns } from "./IIIFImage.vue?vue&type=template&id=6741e940&scoped=true&"
import script from "./IIIFImage.vue?vue&type=script&lang=js&"
export * from "./IIIFImage.vue?vue&type=script&lang=js&"
import style0 from "./IIIFImage.vue?vue&type=style&index=0&id=6741e940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6741e940",
  null
  
)

export default component.exports